/* eslint-disable prettier/prettier */

const historyItems = document.querySelectorAll('.timeline--item') as NodeListOf<HTMLElement>
const containerElem = document.querySelector('.timeline--content') as HTMLElement
const nextBtn = document.querySelector('.timeline--controls--next') as HTMLButtonElement
const prevBtn = document.querySelector('.timeline--controls--prev') as HTMLButtonElement

const scrollToItem = (el: HTMLElement) => {
    
    if (window.innerWidth < 900)
    {
        el.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" })       
    }
    else
    {
        el.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" })       
    }
}

const scrollNext = () => {
   containerElem.scroll({
    top: 0,
    left: containerElem.scrollLeft + 304,
    behavior: 'smooth'
   })
}
const scrollPrev = () => {
    containerElem.scroll({
        top: 0,
        left: containerElem.scrollLeft - 304,
        behavior: 'smooth'
       })
}

export default function initHistoryblock()
{
    // if (historyItems.length > 0)
    // {
    //     historyItems.forEach(item => {
    //         item.addEventListener('mouseover', () => {
    //             scrollToItem(item)
    //         })
    //         item.querySelector('button').addEventListener('focus', () => {
    //             scrollToItem(item)
    //         })
    //     })
    // }
    // if (nextBtn)
    // {
    //     nextBtn.addEventListener('click', scrollNext)
    // }
    // if (prevBtn)
    // {
    //     prevBtn.addEventListener('click', scrollPrev)
    // }
}